import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from '../../ManageSubscription/styles/SubscriptionContainer.module.scss';
import { useHistory } from 'react-router-dom';
import { usePurchaseSubscriptionContext } from '../../PurchaseSubscription/context/PurchaseSubscriptionContext';
import { troubleshoot as events } from '../../../lib/analytics/events';

import AppPaths from '../../../AppPaths';
import SubscriptionAppBar from '../../ManageSubscription/components/SubscriptionAppBar';
import { Image } from '../../../components/Image';

import CollarImage from '../../../assets/images/in_app_cancellation/s3_yellow_flat.png';
import ValuePropsBox from '../../ProductDetails/Series3CollarDetails/components/ValuePropsBox';
import { getWhatsNewValueProps } from '../../ProductDetails/Series3CollarDetails/components/ValuePropsBox/WhatsNewValueProps';
import Button from '../../../components/Button';
import ErrorScreen from '../../ManageSubscription/components/ErrorScreen/ErrorScreen';

export default function UpgradeSeries2() {
  const { t } = useTranslation();
  const history = useHistory();
  const { device } = usePurchaseSubscriptionContext();
  const petName = device.pet?.name ?? t('your_dog');

  events.pageLoad({ petId: device.pet?.id }, 'Upgrade Series 2');

  if (!device.subscription?.id) {
    return <ErrorScreen />;
  }

  const handleUpgrade = () => {
    events.series2UpgradeClicked({ petId: device.pet?.id });
    history.push({
      pathname: AppPaths.Series3Upgrade.SplashPageForPet(device.pet?.id),
      search: window.location.search,
    });
  };

  return (
    <>
      <div className={styles.fullWidthWrapper}>
        <SubscriptionAppBar
          backButtonAnalyticsEvent={() => events.series2UpgradeBack({ petId: device.pet?.id })}
          closeButtonAnalyticsEvent={() => events.series2UpgradeClose({ petId: device.pet?.id })}
        />
        <div className={styles.subscriptionContainer}>
          <h1>{t('upgrade_your_series_2_collar_get_credit_for_series_3')}</h1>
          <p>{t('our_fi_series_3_collar_is_our_smartest_smallest_and_most_resilient_collar_yet', { petName })}</p>
        </div>

        <Image
          className={styles.collarAvatar}
          image={{ type: 'image', url: CollarImage }}
          alt={t('the_fi_series_3_collar_with_a_yellow_band')}
        />
        <div className={styles.whatsNew}>
          <h2>{t('whats_new')}</h2>
          <ValuePropsBox valueProps={getWhatsNewValueProps(t)} />
        </div>
        <div className={styles.buttonContainer}>
          <Button className={styles.button} onClick={handleUpgrade}>
            {t('upgrade_now')}
          </Button>
          {/* Spacer ensures primary button is aligned with buttons on neighboring pages in in-app cancel flow */}
          <div className={styles.buttonSpacer}></div>
        </div>
      </div>
    </>
  );
}
